// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"f43dfa0b","197":"3680d9dc","432":"fc93fb6b","556":"903eba5b","720":"08d3f9f3"}[chunkId] + ".chunk.js";
};